/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_NoteInputs */

const en_svc_agents_art_note = /** @type {(inputs: Svc_Agents_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative agent run. Your rules decide what it may do alone.`)
};

const lv_svc_agents_art_note = /** @type {(inputs: Svc_Agents_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustratīvs aģenta darbs. Jūsu noteikumi nosaka, ko tas drīkst darīt pats.`)
};

/**
* | output |
* | --- |
* | "Illustrative agent run. Your rules decide what it may do alone." |
*
* @param {Svc_Agents_Art_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_note = /** @type {((inputs?: Svc_Agents_Art_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_note(inputs)
	return en_svc_agents_art_note(inputs)
});